module.exports = __webpack_public_path__ + "img/psv.210e1df3.png";